import OnboardingChecklist from './OnboardingChecklist'

export default OnboardingChecklist
